import * as React from 'react';
import { useLanguage } from 'src/providers/LanguageProvider';

const localeMap: Record<string, string> = {
  tr: 'tr-TR',
  en: 'en-US',
  de: 'de-DE',
  nl: 'nl-NL',
};

function safeDate(iso?: string | null) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

const useFormatDate = () => {
  const { language } = useLanguage(); // örn: "tr", "en", "de", "nl"
  const locale = localeMap[language] || language || 'en-US';

  const formatDate = React.useCallback(
    (iso?: string | null) => {
      const d = safeDate(iso);
      if (!d) return '-';
      return d.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      });
    },
    [locale]
  );

  return formatDate;
};

export default useFormatDate;
